import { cva } from '@/styled-system/css';

// Give center slide a higher z-index than other slides to avoid flickering in transitions
export const photoCarouselSlideRecipe = cva({
  base: {
    'inset': '0',
    'position': 'absolute',

    '& > a': {
      display: 'block',
      height: '100%',
    },
  },
  variants: {
    shouldAnimateTranslations: {
      true: {
        transition: {
          _motionReduce: 'none',
          _motionSafe: '{transform 0.2s cubic-bezier(0.58, 0.92, 0.57, 0.92)}',
        },
      },
      false: {},
    },
    slidePosition: {
      center: {
        transform: 'translateX(0%)',
        zIndex: 2,
      },
      left: {
        transform: 'translateX(-100%)',
        zIndex: 1,
      },
      right: {
        transform: 'translateX(100%)',
        zIndex: 1,
      },
    },
  },
});
